import {useEffect, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {getClaimsList, listReferencesCode, listUnitTree} from '../../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {customStyles} from '../../../dataTableStyle'
import DataTable, {TableColumn} from 'react-data-table-component'
import AddReferencesCodeModal from './Modals/ReferencesCodeModals/AddReferencesCodeModal'
import ReferencesCodeDeletionModal from './Modals/ReferencesCodeModals/ReferencesCodeDeletionModal'
import ReferencesCodeEditModal from './Modals/ReferencesCodeModals/ReferencesCodeEditModal'

// Tablo Veri Tipleri
type ReferencesCodeType = {
  code: string
  expireDate: string
  fkId: number
  fkName: string
  id: number
  referencesType: number
  userRole: number
  userRoleName: string
}

function ReferencesCode() {
  const intl = useIntl()
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  const [roles, setRole] = useState<[]>([])
  const [units, setUnits] = useState<[]>([])
  const [referenceCodeList, setReferencesCodeList] = useState<[]>([])
  const [claimId, setClaimId] = useState<number>(0)
  const [unitId, setUnitId] = useState<number>(1)
  const [listing, setListing] = useState<boolean>(false)
  const [selectRCData, setSelectRCData] = useState<[]>([])
  const [selectRCId, setSelectRCId] = useState<number>(0)

  // 👇 Referans Kod Listesi
  const getList = async () => {
    try {
      const {data} = await listReferencesCode(claimId, unitId)
      setReferencesCodeList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
      setReferencesCodeList([])
    }
  }

  // 👇 Role Listesi
  const getListClaims = async () => {
    try {
      const {data} = await getClaimsList()
      setRole(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // 👇 Birim  Listesi
  const getListUnits = async () => {
    try {
      const {data} = await listUnitTree(0, 0)
      setUnits(extractData(data))
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // 👇 Birim Ağaç yapısından değerleri dön
  function extractData(data: any, parentName: string = '') {
    const result: any = []
    data.forEach((item: any) => {
      const fullName = parentName ? `${parentName}|${item.name}` : item.name
      result.push({id: item.id, name: fullName})
      if (item.subList && item.subList.length > 0) {
        result.push(...extractData(item.subList, fullName))
      }
    })
    return result
  }

  useEffect(() => {
    getListClaims()
    getListUnits()
  }, [])

  useEffect(() => {
    if (listing) {
      getList()
      setListing(false)
    }
  }, [listing])

  const columns: TableColumn<ReferencesCodeType>[] = [
    {
      name: 'Id',
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: 'Code',
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: 'Expire Date',
      sortable: true,
      cell: (row) => {
        const isExpired = new Date().getTime() > new Date(row.expireDate).getTime()

        return !isExpired ? (
          <span className='badge badge-light-success fs-6'>
            {new Date(row.expireDate).toLocaleDateString()}
          </span>
        ) : (
          <span className='badge badge-light-danger fs-6'>
            {new Date(row.expireDate).toLocaleDateString()}
          </span>
        )
      },
    },
    {
      name: 'Unit',
      selector: (row) => row.fkName,
      sortable: true,
    },
    {
      name: 'User Role',
      selector: (row) => row.userRoleName,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row: any) => (
        <div>
          <a
            type='button'
            className='btn btn-icon btn-light-warning'
            data-bs-toggle='modal'
            data-bs-target='#editReferencesCode_modal'
            onClick={() => setSelectRCData(row)}
          >
            <i className='las la-edit fs-1' />
          </a>
          <a
            type='button'
            className='btn btn-icon btn-light-danger'
            data-bs-toggle='modal'
            data-bs-target='#deleteReferencesCode_modal'
            onClick={() => setSelectRCId(row.id)}
          >
            <i className='las la-trash fs-1' />
          </a>
        </div>
      ),
    },
  ]

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.REFERENCES_CODE'})}</PageTitle>
      {/* 👇 List Reference Code Card 👇 */}
      <div className='card card-custom gx-xl-8 mt-lg-n16 mt-2'>
        <div className='col-xxl-12'>
          <div className='card card-flush p-5 mb-5'>
            <div className='mb-10 row'>
              <div className='mb-10 row'>
                {/* 👇 Role 👇 */}
                <div className='col'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'USER.ROLE'})}
                  </label>

                  <select
                    className='form-select form-select-solid'
                    data-kt-select2='true'
                    data-placeholder='Select option'
                    data-allow-clear='true'
                    value={claimId}
                    onChange={(e) => setClaimId(Number(e.target.value))}
                  >
                    <option value={0}>{intl.formatMessage({id: 'USER.ALLROLE'})}</option>
                    {roles.map((item: any, index: number) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* 👆 Role 👆 */}
                {/* 👇 Unit  👇 */}
                <div className='col'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'USER.UNIT'})}
                  </label>
                  <select
                    className='form-select form-select-solid'
                    data-kt-select2='true'
                    data-placeholder='Select option'
                    data-allow-clear='true'
                    value={unitId}
                    onChange={(e) => setUnitId(Number(e.target.value))}
                  >
                    <option value={0}>{intl.formatMessage({id: 'USER.ALLUNIT'})}</option>
                    {units.map((item: any, index: number) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* 👆 Unit 👆 */}
              </div>

              {/* 👇 Listing Button  👇 */}
              <div className='d-flex justify-content-end'>
                <button type='button' className='btn btn-primary' onClick={() => setListing(true)}>
                  {intl.formatMessage({id: 'USER.LIST'})}
                </button>

                <a
                  className='btn btn-light-success ms-2'
                  data-bs-toggle='modal'
                  data-bs-target='#addReferencesCode_modal'
                >
                  <KTIcon iconName='plus' className='fs-3' />
                  {intl.formatMessage({id: 'REFERENCE_CODE.ADD_CODE'})}
                </a>
              </div>
              {/* 👆 Listing Button   👆 */}
            </div>
          </div>
        </div>
        {/* 👆 List Reference Code Card 👆 */}
      </div>
      <div className='card card-custom mt-4 '>
        <div className='card-body table-responsive'>
          <DataTable
            columns={columns}
            data={referenceCodeList}
            pagination
            paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
            customStyles={customStyles}
            className='table table-striped'
            striped
            paginationDefaultPage={page}
            onChangePage={(e) => setPage(e)}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(e) => setRowsPerPage(e)}
          />
        </div>
      </div>
      {/* 👇 Modals  👇 */}
      <AddReferencesCodeModal />
      <ReferencesCodeDeletionModal id={selectRCId} setAction={setListing} />
      <ReferencesCodeEditModal editData={selectRCData} setAction={setListing} />
      {/* 👆 Modals  👆 */}
    </>
  )
}

export default ReferencesCode
